/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Badge,
  Box,
  Card,
  Checkbox,
  CircularProgress,
  Divider,
  Heading,
  HStack,
  Image,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  VStack,
  Center,
} from '@chakra-ui/react';
import { getAgreementPlans } from '@/service/subscription/api';
import React, { PropsWithChildren, useCallback, useMemo, useState } from 'react';
import { FaCheck } from 'react-icons/fa';
import { useTheme } from '../../../contexts/ThemeProvider';
import { useProfile } from '@/contexts/ProfileProvider';
import { useNavigate } from 'react-router-dom';
import { IPlan } from '@/service/types';
import { Button } from '@/components/atoms/Button';
import { ExternalLink } from '@/components/atoms/ExternalLink';

function Feature({ children }: PropsWithChildren) {
  return (
    <HStack width={'100%'}>
      <Box minWidth={'30px'}>
        <FaCheck color="green" fontSize={'18px'} />
      </Box>
      <Text>{children}</Text>
    </HStack>
  );
}

//TODO: Deixar mais claro qual é o plano atual
//TODO: Falta a qujantidade de audiobooks
//TODO: Ordernar os convenios por ordem, clube -> livro
//TODO: Subir 6 Reais no plano da revista safira e diamante
//TODO: PLANO para produtos
//TODO: TROCAR ASSinatura para outra palavra

export const badges = [
  {
    name: 'Bronze',
    level: 1,
    image: 'badges/bronze.png',
  },
  {
    name: 'Prata',
    level: 2,
    image: 'badges/prata.png',
  },
  {
    name: 'Ouro',
    level: 3,
    image: 'badges/ouro.png',
  },
  {
    name: 'Safira',
    level: 4,
    image: 'badges/safira.png',
  },
  {
    name: 'Diamante',
    level: 5,
    image: 'badges/diamante.png',
  },
];

interface Conv {
  id: number | null;
  nome: string;
  logo: string;
  isClube: boolean;
  bookstoreTypes: string[];
  isAudioBook: boolean;
}

let planos = [2612, 2615, 2609, 2618, 2621, 2624, 2606, 2603, 2598, 2595];

export function Plans() {
  const { id, colors, isIOS, isApp, hasIntegratedPurchaseOnMobileStore, childrenList } = useTheme();

  const { profile } = useProfile();
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState(false);

  const [selectedConvenio, setSelectedConvenio] = useState<string>();
  const [plans, setPlans] = useState<any>([]);
  const [loadingPlans, setLoadingPlans] = useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);

  const disabledLevel = useMemo(() => {
    if (!profile) return;

    const foundSub = profile.subscriptions.find((sub) => sub.plan.agreement.id === Number(selectedConvenio));

    return foundSub?.plan.id;
  }, [profile, selectedConvenio]);

  const handleGetPlans = useCallback(
    async (idConv: string) => {
      if (id) {
        setLoadingPlans(true);
        const plansFetch = await getAgreementPlans({ agreementID: idConv });

        let plansValues = plansFetch.sort((a: any, b: any) => a.level - b.level);

        setPlans(plansValues);

        // Encontrar o índice do plano atual
        if (disabledLevel) {
          const currentPlanIndex = plansFetch.findIndex((p: any) => p.id === disabledLevel);
          if (currentPlanIndex !== -1) {
            setSelectedTabIndex(currentPlanIndex);
          }
        }
      }
      setLoadingPlans(false);
    },
    [disabledLevel]
  );

  const [convenios, setConvenios] = useState<Conv[]>([]);

  const navigate = useNavigate();

  const openVindi = useCallback((plan: IPlan) => {
    setLoading(true);

    if (isApp && isIOS && hasIntegratedPurchaseOnMobileStore) {
      navigate(`/perfil/planos/purchase-subscription-mobile/${btoa(profile?.cpf + ':' + id)}`);
    }

    setTimeout(() => {
      window.open(plan.vindiPage + '?payload=' + plan.vindiPayload, '_blank');
      setLoading(false);
    }, 2000);
  }, []);

  React.useEffect(() => {
    if (childrenList) {
      const conv: Conv[] = [];
      childrenList.forEach((chil: any) => {
        conv.push({
          id: chil.id,
          nome: chil.name,
          logo: chil.logo,
          isClube: chil.localModule || chil.ecommerceModule,
          bookstoreTypes: chil.bookstoreTypes,
          isAudioBook: !!chil.bookstoreTypes.find((b: any) => b === 'audiobook'),
        });
      });

      conv.sort((a: any) => (a.id === id ? -1 : 1));

      console.log('convenios', conv);
      if (conv.length > 0 && conv[0]?.id !== null) {
        setSelectedConvenio(conv[0].id.toString());
        handleGetPlans(conv[0].id.toString());
      }

      setConvenios(conv);
    }
  }, [childrenList]);

  if (!plans || plans.length === 0) return <Loading />;

  const MSG_TERMOS = 'Estou de acordo com os';
  const MSG_TERMOS_DE_USO = 'Termos de Uso';
  const MSG_MENSAIS = 'Mensais';
  const MSG_ESSE_E_SEU_PLANO = 'Esse é seu benefício atual';
  const MSG_ASSINAR = 'Comprar';

  // Mapeamento de mensagens por tipo de convênio
  const PLAN_TYPE_MESSAGES = {
    clube: [
      (p: any) => `Garanta ${p.accessAmount} acessos à plataforma.`,
      () => 'Mais de 1000 descontos em lojas próximas de você.',
      () => 'Centenas de cinemas parceiros com descontos.',
      () => 'Dezenas de parceiros ecommerce com descontos.',
    ],
    magazine: [
      (p: any) => `Todo mês ${p.magazineQuantity} Revistas especiais para você.`,
      () => 'Não gostou das revistas? Você pode trocar por um outro na banca.',
      (p: any) => `Garanta ${p.accessAmount} acessos à plataforma.`,
    ],
    livro: [
      (p: any) => `Todo mês ${p.bookQuantity} Livros especiais para você.`,
      () => 'Não gostou dos livros? Você pode trocar por um outro no acervo.',
      (p: any) => `Garanta ${p.accessAmount} acessos à plataforma.`,
    ],
    audiobook: [
      (p: any) => `Todo mês ${p.bookQuantity} Livros e ${p.audiobookQuantity} Audiobooks especiais para você.`,
      () => 'Não gostou das livros ou audiobook? Você pode trocar por um outro no acervo',
      (p: any) => `Garanta ${p.accessAmount} acessos à plataforma.`,
    ],
  };

  function getPlanType(conv: Conv): keyof typeof PLAN_TYPE_MESSAGES {
    if (conv.isClube) return 'clube';
    if (conv.bookstoreTypes?.includes('magazine')) return 'magazine';
    if (conv.isAudioBook) return 'audiobook';
    if (conv.bookstoreTypes?.includes('book')) return 'livro';
    return 'clube'; // fallback
  }

  // Novo componente para features do plano
  function PlanFeatures({ conv, plan }: { conv: Conv; plan: any }) {
    // VStack já está importado do Chakra UI no topo do arquivo
    const planType = getPlanType(conv);
    return (
      <VStack>
        {PLAN_TYPE_MESSAGES[planType].map((msgFn, idx) => (
          <Feature key={idx}>{msgFn(plan)}</Feature>
        ))}
      </VStack>
    );
  }

  // Componente reutilizável de loading
  function Loading() {
    return (
      <Center width="100%" height="40vh">
        <CircularProgress isIndeterminate color={'black'} />
      </Center>
    );
  }
  return (
    <VStack
      spacing={5}
      flexDirection={{
        base: 'column',
        md: 'row',
      }}
      maxWidth={planos.includes(id || 0) ? '600px' : '100%'}
      align={'flex-start'}
      width={'100%'}
    >
      {!planos.includes(id || 0) && (
        <Stack
          justifyContent={{
            base: 'flex-start',
          }}
          alignItems={'center'}
          width={{
            base: '100%',
            md: '50%',
          }}
          overflowX={{
            base: 'auto',
            md: 'hidden',
          }}
          padding="20px"
          flexDirection={{
            base: 'row',
            md: 'column',
          }}
          spacing={4}
          bg="#F1F4F5"
        >
          {convenios
            .sort((a, b) => {
              // Primeiro: clube (isClube = true)
              if (a.isClube && !b.isClube) return -1;
              if (!a.isClube && b.isClube) return 1;

              // Segundo: livros (regex no nome)
              const aIsLivro = /livro/i.test(a.nome);
              const bIsLivro = /livro/i.test(b.nome);
              if (aIsLivro && !bIsLivro) return -1;
              if (!aIsLivro && bIsLivro) return 1;

              // Terceiro: revista (regex no nome)
              const aIsRevista = /revista/i.test(a.nome);
              const bIsRevista = /revista/i.test(b.nome);
              if (aIsRevista && !bIsRevista) return -1;
              if (!aIsRevista && bIsRevista) return 1;

              // Por último: ordenar por ID
              return (a.id || 0) - (b.id || 0);
            })

            .map((c) => (
              <Card
                key={c.id}
                onClick={() => {
                  if (c.id) {
                    setSelectedConvenio(c.id?.toString());
                    handleGetPlans(c.id?.toString());
                  }
                }}
                cursor="pointer"
                padding="20px"
                borderRadius="lg"
                boxShadow={selectedConvenio === c.id?.toString() ? `0 0 10px ${colors.primaryColor}` : 'md'}
                width="250px"
                minWidth={'250px'}
                _hover={{
                  boxShadow: 'lg',
                  transform: 'scale(1.02)',
                  transition: 'all 0.2s ease-in-out',
                }}
              >
                <VStack spacing={4}>
                  <Image src={c.logo} alt={c.nome} height={'50px'} />
                  <Heading textAlign={'center'} fontSize={'20px'}>
                    {c.nome}
                  </Heading>
                </VStack>
              </Card>
            ))}
        </Stack>
      )}
      {!loadingPlans ? (
        <Card
          padding={{
            base: '20px',
            md: '30px',
          }}
          width={{
            base: '100%',
            md: planos.includes(id || 0) ? '100%' : '50%',
          }}
        >
          <Tabs isFitted width={'100%'} variant="soft-rounded" index={selectedTabIndex} onChange={setSelectedTabIndex}>
            <TabList
              width={'100%'}
              overflowX={'auto'}
              border={'1px solid #e2e8f0'}
              borderRadius={'12px'}
              gap={0}
              bg={'white'}
              boxShadow={'0 2px 8px rgba(0, 0, 0, 0.05)'}
              padding={'6px'}
            >
              {plans
                .filter((p: any) => {
                  if (planos.includes(id || 0)) {
                    return p.name === 'Bronze';
                  }
                  return true;
                })
                .map((p: any) => (
                  <Tab
                    textOverflow={'ellipsis'}
                    whiteSpace={'nowrap'}
                    padding={'8px 16px'}
                    borderRadius={'8px'}
                    margin={'2px'}
                    _selected={{
                      color: 'white',
                      backgroundColor: colors.primaryColor,
                      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                      transform: 'translateY(-1px)',
                    }}
                    key={p.id}
                  >
                    <VStack spacing={1} minH={'45px'} justify={'center'}>
                      <Text fontWeight={'600'} fontSize={'13px'} textAlign={'center'}>
                        {p.name}
                      </Text>
                      {disabledLevel === p.id && (
                        <Badge
                          colorScheme="green"
                          fontSize="9px"
                          borderRadius="full"
                          px={2}
                          py={0.5}
                          fontWeight={'500'}
                          textTransform={'uppercase'}
                          letterSpacing={'0.3px'}
                        >
                          Plano atual
                        </Badge>
                      )}
                    </VStack>
                  </Tab>
                ))}
            </TabList>
            <TabPanels>
              {plans.map((p: any) => (
                <TabPanel key={p.id}>
                  <VStack spacing={6} w={'100%'} align={'flex-start'}>
                    <Box margin="auto">
                      {badges.find((b) => b.level === p.level) && (
                        <Image
                          src={`/${badges.find((b) => b.level === p.level)?.image}`}
                          alt={p.name}
                          height={'80px'}
                        />
                      )}
                    </Box>
                    <HStack
                      alignSelf={'center'}
                      padding={'20px 0px'}
                      spacing={2}
                      justify={'flex-start'}
                      align="flex-start"
                    >
                      <Heading margin={'0px'} fontSize={'18px'}>
                        R$
                      </Heading>
                      <Heading lineHeight={'50px'} fontSize={'60px'}>
                        {p.value.split('.')[0]}
                      </Heading>
                      <Heading>,{p.value.split('.')[1]}</Heading>
                      <Heading alignSelf={'flex-end'} fontSize={'12px'}>
                        {MSG_MENSAIS}
                      </Heading>
                    </HStack>
                    <Divider />
                    {(() => {
                      const conv = convenios?.find((con) => con.id?.toString() === selectedConvenio);
                      if (!conv) return null;
                      return <PlanFeatures conv={conv} plan={p} />;
                    })()}

                    {disabledLevel !== p.id && (
                      <VStack
                        margin="auto"
                        spacing={6}
                        width={{
                          base: '100%',
                          sm: 'auto',
                        }}
                      >
                        <Checkbox isChecked={terms} onChange={(e) => setTerms(e.target.checked)}>
                          {MSG_TERMOS}{' '}
                          <ExternalLink color={colors.primaryColor} to={'/legal/termos-de-uso'} target="blank">
                            {MSG_TERMOS_DE_USO}
                          </ExternalLink>
                        </Checkbox>

                        <Button
                          isLoading={loading}
                          onClick={() => openVindi(p)}
                          isDisabled={!terms || disabledLevel === p.id}
                        >
                          {disabledLevel === p.id ? MSG_ESSE_E_SEU_PLANO : MSG_ASSINAR}
                        </Button>
                      </VStack>
                    )}
                  </VStack>
                </TabPanel>
              ))}
            </TabPanels>
          </Tabs>
        </Card>
      ) : (
        <Card
          padding={{
            base: '20px',
            md: '30px',
          }}
          width={{
            base: '100%',
            md: '50%',
          }}
          height={{
            base: '30vh',
            md: '60vh',
          }}
          display={'flex'}
          align={'center'}
          justifyContent={'center'}
        >
          <Loading />
        </Card>
      )}
    </VStack>
  );
}
